(() => {
  if (customElements.get('layout-controls')) {
    return;
  }

  class LayoutControls extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    init() {
      this.buttons = this.querySelectorAll('[data-button]');
      this.compactGridBreakpoint = '(max-width: 1365px)';
      this.sessionKey = 'grid-layout';

      const isCompactGrid = window.matchMedia(
        this.compactGridBreakpoint,
      ).matches;
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const hasGridColumnsParameter = urlParams.has('grid_columns');

      if (!hasGridColumnsParameter) {
        const savedLayout = sessionStorage.getItem(this.sessionKey);

        if (isCompactGrid && savedLayout == 6) {
          this.updateSessionVariable(4);
        }

        this.updateLayout(!savedLayout, true);
      } else {
        const currentLayout = urlParams.get('grid_columns');

        if (isCompactGrid && currentLayout == 6) {
          this.updateSessionVariable(4);
          this.updateLayout(false, true);
        } else {
          this.updateSessionVariable(currentLayout);
          this.updateLayout(false, true, false);
        }
      }
    }

    attachEvents() {
      this.debouncedOnResize = debounce(() => {
        const currentLayout = sessionStorage.getItem(this.sessionKey) || 4;
        const isCompactGrid = window.matchMedia(
          this.compactGridBreakpoint,
        ).matches;

        if (!isCompactGrid || currentLayout != 6) {
          return
        }

        this.updateSessionVariable(4);
        this.updateLayout(false, true);
      }, 100);

      window.addEventListener('resize', this.debouncedOnResize.bind(this));

      this.buttons.forEach(button => {
        button.addEventListener('click', () => {
          if (button.classList.contains('is-active')) {
            return;
          }

          this.updateSessionVariable(button.dataset.gridItems || 4);
          this.updateLayout();
        });
      });

      document.addEventListener('shopify:section:load', this.updateLayout.bind(this));
    }

    updateLayout(flag, preservePage = false, updateHistory = true) {
      this.currentLayout = sessionStorage.getItem(this.sessionKey) || 4;

      if (this.currentLayout == 4 && flag === true) {
        document.querySelector(this.dataset.container)?.classList.remove('is-hidden');

        return;
      }

      this.updateContainer(preservePage, updateHistory);

      this.updateButtons();
    }

    async fetchContainer(preservePage = false, updateHistory = true) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const hasPageParameter = urlParams.has('page');
      const hasGridColumnsParameter = urlParams.has('grid_columns');
      const variantParameterValue = Math.floor(Date.now() * Math.random());

      if (hasPageParameter && !preservePage) {
        urlParams.delete('page');
      }

      if (hasGridColumnsParameter) {
        urlParams.delete('grid_columns');
      }

      urlParams.set('grid_columns', this.currentLayout);
      urlParams.delete('variant');
      const requestParams = new URLSearchParams(urlParams);
      requestParams.set('variant', variantParameterValue);

      const fetUrl = `${window.location.origin}${window.location.pathname}?${requestParams.toString()}`;
      let containerMarkup = '';

      if (updateHistory) {
        this.updateURL(urlParams.toString());
      }

      await fetch(fetUrl)
        .then((response) => response.text())
        .then((response) => {
          if (response.status) {
            alert(response.description);
            return;
          }

          containerMarkup = new DOMParser()
          .parseFromString(response, 'text/html')
          .querySelector(this.dataset.container).innerHTML;
        })
        .catch((error) => {
          console.error(error);
        });

      return containerMarkup;
    }

    updateButtons() {
      this.buttons.forEach(button => {
        button.classList.toggle('is-active', button.dataset.gridItems == this.currentLayout);
        button.setAttribute('aria-pressed', String(button.dataset.gridItems == this.currentLayout));
      });
    }

    async updateContainer(preservePage = false, updateHistory = true) {
      const gridContainer = document.querySelector(this.dataset.container);
      const requestId = (this.requestId || 0) + 1;
      this.requestId = requestId;

      gridContainer.classList.add('is-loading');

      const containerMarkup = await this.fetchContainer(preservePage, updateHistory);

      if (requestId != this.requestId || containerMarkup == '') {
        return;
      }

      gridContainer.innerHTML = containerMarkup;

      gridContainer.classList.remove('is-loading', 'is-hidden');
    }

    updateSessionVariable(layout) {
      sessionStorage.setItem(this.sessionKey, layout);
    }

    updateURL(searchParams) {
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
      );
    }
  
  }

  customElements.define('layout-controls', LayoutControls);
})();
